// DS: i7.25
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const EditorStrike: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M12 6C9.741 6 8.625 7.288 8.625 8.5c0 .704.257 1.294.747 1.72.501.436 1.34.78 2.628.78h6a1 1 0 110 2H6a1 1 0 110-2h1.397c-.518-.73-.772-1.596-.772-2.5C6.625 5.846 9.009 4 12 4c2.765 0 5.003 1.562 5.335 3.923a1 1 0 11-1.98.279C15.2 7.11 14.081 6 12 6zM14.75 14c.417.441.625.978.625 1.5 0 .704-.257 1.294-.748 1.72-.5.436-1.339.78-2.627.78-2.15 0-3.06-.928-3.3-1.871a1 1 0 10-1.938.492C7.289 18.697 9.216 20 12 20c1.635 0 2.984-.44 3.94-1.27.966-.84 1.435-2.001 1.435-3.23 0-.536-.097-1.039-.277-1.5h-2.347z"></path>
      </svg>
    </IconWrap>
  );
};
EditorStrike.displayName = 'EditorStrike';

export default EditorStrike;
